// Fixed canvas size in screen space (never changes)
export const CANVAS_WIDTH = 4000;
export const CANVAS_HEIGHT = 2500;

// Grid spacing in screen pixels (never changes)
export const GRID_SIZE_PX = 10;

// Every block has the SAME footprint so cards never warp on load.
// Halved from the previous 300×150 to a more compact 150×75 px
// (15 × 7.5 grid units). The width is the canonical anchor for the
// hyphenation logic in `nameHyphenate.ts`.
export const BLOCK_WIDTH_PX = 150;
export const BLOCK_HEIGHT_PX = 75;
// Legacy grid-unit aliases. Kept as plain numbers (no longer multiples
// of GRID_SIZE_PX in both dimensions) for any callers that read them.
export const BLOCK_WIDTH_GRID = BLOCK_WIDTH_PX / GRID_SIZE_PX;   // 15
export const BLOCK_HEIGHT_GRID = BLOCK_HEIGHT_PX / GRID_SIZE_PX; // 7.5

// Max characters allowed in `config.description` before the editor
// surfaces the "Summarize → details" AI button. Beyond this length the
// short summary stops fitting on a 30×15 card.
export const DESCRIPTION_SOFT_LIMIT = 200;
